
const dataClients = [
  {
    title: 'Entreprises',
    img: 'corporate',
    content: "Portrait / Reportage / Evénementiel / Trombinoscope",
    content2:"Publicité / Packshot / Architecture"
  },
  {
    title: 'Particuliers',

    img: 'particuliers',
    content: "Portrait / Mariage",
    content2:"Cours de photo"

  },
  {
    title: 'Artistes',

    img: 'artistes',
    content: "Comédiens / Musiciens / Danseurs / Ecrivains",
    content2:"Mannequins / Création d’univers visuel"


  }
];

export default dataClients
